// MODULES
import { LotI, NftAPI, NFTI } from '@tacans/shared-marketplace-layer';
import { useTranslation } from 'next-i18next';
import React, { useCallback, useMemo } from 'react';
import { PlaceBidModal } from 'src/features/common/collectible/modals/place-bid-modal';
import { useGetUniverseTemplate } from 'src/hooks/use-get-universe-template';
// RESOURCES
import { Button } from 'src/ui/common/atoms/button';
import { getAuctionStatus } from 'src/utils/lot.utils';
import { useGetActiveTokenTransaction } from '../../hooks/useGetActiveTokenTransaction.hook';
import { useActionWithAuthorization } from './actions.hooks';

interface PlaceBidButtonI {
    lot: LotI;
    nft: NFTI;
    small?: boolean;
}

interface ILocale {
    placeBid: string;
}

export const PlaceBidAction = ({ lot, nft, small }: PlaceBidButtonI) => {
    const { t } = useTranslation(['actions']);
    const locale: ILocale = useMemo(
        () => ({
            placeBid: t('trade.placeBid', { ns: 'actions' }),
        }),
        [t]
    );
    const { isAuctionStarted } = getAuctionStatus(lot?.auctionStartAt, lot?.auctionEndAt);
    const { isOceanTemplate } = useGetUniverseTemplate();

    const activeTransactions = useGetActiveTokenTransaction();

    const placeBidCallback = useCallback(async () => {
        const addressResponse = await NftAPI.fetchScAddress(lot.nftId);
        const { address = '' } = addressResponse.data;
        const scInfoPayload = address ? { address } : { standard: nft.standard.toUpperCase() };

        PlaceBidModal.open({
            nft,
            lot,
            scInfoPayload,
        });
    }, [nft, lot]);

    const actionWithAuthorization = useActionWithAuthorization({
        callback: placeBidCallback,
    });

    const getButtonVariant = useCallback(() => {
        if (isOceanTemplate) {
            return 'o_purple';
        }
        return 'gradient';
    }, [isOceanTemplate]);

    return (
        <>
            <Button
                onClick={actionWithAuthorization}
                size={small ? 'sm' : 'lg'}
                disabled={!!activeTransactions[0] || !isAuctionStarted}
                data-test-id="place-bid-btn"
                variant={getButtonVariant()}
            >
                {locale.placeBid}
            </Button>
        </>
    );
};
